(function() {
  "use strict";

  angular.module("UserPropertiesMulti")
    .controller("UserPropertiesMultiController", [
      "$scope", 'EventHandlerService',
      function(
        $scope, EventHandlerService) {

        $scope.users = null;
        $scope.autoDeleteAllUsers = false;
        $scope.deleteUserAfterNoActivityAfterNDays = 10;
        //                $scope.userRoles = USER_ROLES;
        $scope.eventHandlerService = EventHandlerService;

        (function(){
          initEventHandler();
        })();
        
        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.toggleDeleteUsersAfterDaysNotActive = function() {
          $scope.autoDeleteAllUsers = !$scope.autoDeleteAllUsers;
          angular.forEach($scope.users, function(user) {
            user.info.inactivityAutoDelete = $scope.autoDeleteAllUsers;
          });
        };

        $scope.saveChanges = function() {};

      }
    ]);
})();
